<template>
    <vue-select
        v-bind="$attrs"
        v-on="$listeners"
        :options="senders"
        :getOptionLabel="(opt) => {
            if (opt.ui_json && opt.ui_json.name) {
                return opt.ui_json.name;
            }
            return opt.tag;
        }"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på leveranssätt</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import NtapsSendersRepository from '@services/repositories/NtapsSendersRepository';

export default {
    name: 'NtapsSendersFilter',
    components: {
        VueSelect,
    },
    props: {
        deliveryServiceId: {
            type: Number,
            default: null,
        },
    },
    watch: {
        deliveryServiceId() {
            this.updateSenders();
        },
    },
    data() {
        return {
            senders: [],
        };
    },
    created() {
        this.updateSenders();
    },
    methods: {
        async updateSenders() {
            const sendersRpository = new NtapsSendersRepository();
            const allSenders = await sendersRpository.getAll();

            if (this.deliveryServiceId !== null) {
                const filteredSenders = allSenders.filter((sender) => sender.delivery_service_id === this.deliveryServiceId);
                this.senders = filteredSenders;

                if (filteredSenders.length === 1) {
                    if (this.$attrs.reduce instanceof Function) {
                        this.$emit('input', this.$attrs.reduce(filteredSenders[0]));
                    } else {
                        this.$emit('input', filteredSenders[0]);
                    }
                } else {
                    const option = filteredSenders.find((sender) => this.$attrs.reduce(sender) === this.$attrs.value);
                    if (option) {
                        this.$emit('input', this.$attrs.reduce(option));
                    } else {
                        this.$emit('input', null);
                    }
                }
            } else {
                this.senders = allSenders;
            }
        },
    },
};
</script>
